import Vue from 'vue'

import 'ant-design-vue/dist/antd.css'
import AntUI from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/app.scss'
import VueAnimateNumber from 'vue-animate-number'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.use(AntUI)
Vue.use(VueAnimateNumber)

Vue.config.productionTip = false
const user = JSON.parse(localStorage.getItem('user'))
if (user && user.code === 'sdu') {
  document.title = '山东大学知识产权数字图谱'
  document.querySelector('link[rel="icon"]').setAttribute('href', 'static/sddx.ico')
}
if (user && user.code === 'gdut') {
  document.title = '广东工业大学知识产权数字图谱'
  document.querySelector('link[rel="icon"]').setAttribute('href', 'static/gdut.ico')
}
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
